// extracted by mini-css-extract-plugin
export default {"label":"yrE28U"};